import { useNavigate } from "react-router-dom";

import { CustomButton } from "../../../shared/uiComponents";
import { IncompleteNotesSummary } from "../../../redux/State/clientSlice/dashboardSlice";
import { WarningTriangleSvg } from "../../../shared/Assets/svgIcons";

const formatExpiryText = (hours: number | null): string => {
  if (hours === null || hours <= 0) return "";

  let timeStr: string;
  if (hours < 1) timeStr = `${Math.round(hours * 60)} minutes`;
  else if (hours < 24) timeStr = `${Math.round(hours)} hours`;
  else {
    const days = Math.floor(hours / 24);
    timeStr = `${days} day${days !== 1 ? "s" : ""}`;
  }

  return `Expires in ${timeStr}`;
};

interface IncompleteNotesWidgetProps {
  summary: IncompleteNotesSummary;
}

const IncompleteNotesWidget = ({ summary }: IncompleteNotesWidgetProps) => {
  const navigate = useNavigate();

  if (summary.count === 0) return null;

  const draftCount = summary.draftCount ?? 0;
  const notStartedCount = summary.notStartedCount ?? 0;
  const expiryText = formatExpiryText(summary.soonestExpiryHours);

  const handleCompleteNow = () => {
    navigate("/soap-notes");
  };

  const titleText = `You have ${summary.count} incomplete note${summary.count !== 1 ? "s" : ""}`;

  const detailParts: string[] = [];
  if (draftCount > 0) detailParts.push(`${draftCount} draft`);
  if (notStartedCount > 0) detailParts.push(`${notStartedCount} not started`);
  const detailText = detailParts.length > 0 ? ` (${detailParts.join(", ")})` : "";

  const actionText = `Complete ${summary.count === 1 ? "it" : "them"} to avoid billing issues.`;
  const subtitleText = expiryText
    ? `${expiryText} • ${actionText}${detailText}`
    : `${actionText}${detailText}`;

  return (
    <div className="btIncompleteAlert">
      <div className="btIncompleteAlertIcon">
        <WarningTriangleSvg />
      </div>
      <div className="btIncompleteAlertText">
        <span className="btIncompleteAlertTitle">
          {titleText}
        </span>
        <span className="btIncompleteAlertSub">
          {subtitleText}
        </span>
      </div>
      <CustomButton
        className="btIncompleteAlertAction"
        title="Complete Now"
        sizeType="sm"
        onClick={handleCompleteNow}
        style={{ background: "#E77878", border: "1px solid #E77878", borderRadius: "6px" }}
      />
    </div>
  );
};

export default IncompleteNotesWidget;
